/** Строка для UI/писем: юрлицо, при отсутствии — торговое имя (legacy). */
export function contractorDisplayName(c: { legal_entity?: string | null; name?: string | null }): string {
  const le = c.legal_entity?.trim();
  if (le) return le;
  return (c.name ?? '').trim();
}
